// removed by extract-text-webpack-plugin
module.exports = {"itemGallery":"_2OKUpUlxaT__eYmocNyT7n","select":"_2vS9jeNe6QOKiQnbKjn0L2","selected":"LhuqVZg-O-pEGLTkTAPaw"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Components/Gallery/style.css
// module id = 401
// module chunks = 39